
import {
  NodeBasicPage,
  NodeParagraphsPage,
  NodeLandingPage,
  NodeOverviewPage,
  NodeArticle,
  NodePartner,
  NodeContactPerson,
  NodeExpert,
  NodeFaq,
  NodeDownload,
  NodeEvent,
  NodeHomePage,
  NodePracticalExamplePage,
  NodeInterventionPage,
  NodeResearch,
  NodeELearningPage,
  NodeExternalPublication,
  NodeAuthor,
  NodeResult,
} from '../implementations';

const mappers = {
  basic_page: NodeBasicPage,
  paragraphs_page: NodeParagraphsPage,
  landing_page: NodeLandingPage,
  overview_page: NodeOverviewPage,
  article: NodeArticle,
  partner: NodePartner,
  expert: NodeExpert,
  faq: NodeFaq,
  download: NodeDownload,
  event: NodeEvent,
  home_page: NodeHomePage,
  vacature: NodeBasicPage,
  tool: NodeArticle,
  praktijkvoorbeeld: NodePracticalExamplePage,
  interventie: NodeInterventionPage,
  onderzoek: NodeResearch,
  e_learning: NodeELearningPage,
  externe_publicatie: NodeExternalPublication,
  auteur: NodeAuthor,
  contact_person: NodeContactPerson,
  result: NodeResult,
};

export default mappers;
